/**
 * Helper utilities for opening contact forms via HelpScout Beacon
 * Window.Beacon type is defined in src/types/global.d.ts
 */

/**
 * Opens HelpScout Beacon with pre-filled Tiered Pricing contact form
 * Used when non-tiered users need more than 10 channels
 */
export function openTieredPricingContactForm(userName?: string): void {
  if (!window.Beacon) {
    console.warn('HelpScout Beacon not available')
    return
  }

  // Configure Beacon with maximum z-index to appear above Dialog
  // Note: We don't reset() here as that would close an already-open Beacon
  window.Beacon('config', {
    display: {
      zIndex: 999999, // Higher than Dialog overlay but not max to avoid browser limits
    },
    messaging: {
      contactForm: {
        customFieldsEnabled: false,
      },
    },
  })

  window.Beacon('prefill', {
    name: userName,
    subject: 'Volume pricing options for my organization',
    text: '- The number of channels I need to connect is... \n- The number of users who need access to my Buffer organization is...',
  })

  window.Beacon('navigate', '/ask/message/')
  window.Beacon('open')

  // Manually set z-index on Beacon container after opening
  // This ensures the z-index is applied even if config doesn't work
  setTimeout(() => {
    const beaconContainer = document.getElementById('BeaconContainer')
    const beaconFab = document.getElementById('BeaconFabButtonFrame')
    if (beaconContainer) {
      beaconContainer.style.zIndex = '999999'
    }
    if (beaconFab) {
      beaconFab.style.zIndex = '999999'
    }
  }, 100)
}
